import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

const TILES = [
  { img: IMAGES.galleryGhats, alt: "Sunrise over temple ghats with calm water reflections", tag: "Spiritual & Heritage", tagCls: "text-amber-300", title: "Varanasi & Ayodhya" },
  { img: IMAGES.galleryMunnar, alt: "Tea plantations of Munnar with morning mist", tag: "Hill Stations & Backwaters", tagCls: "text-emerald-300", title: "Kerala & Coorg" },
  { img: IMAGES.galleryJaisalmer, alt: "Golden sand dunes of Jaisalmer with camels at sunset", tag: "Royal Rajasthan", tagCls: "text-amber-300", title: "Jaisalmer & Udaipur" },
  { img: IMAGES.gallerySingapore, alt: "Illuminated skyline of Singapore at dusk", tag: "International Escapes", tagCls: "text-sky-300", title: "Singapore & Malaysia" },
];

export const Gallery = () => (
  <section id="gallery" className="py-20 bg-stone-900 text-white" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs font-bold tracking-widest text-amber-400 uppercase">Visual Journey</span>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mt-2 font-serif-display">
          Glimpses from journeys we plan
        </h2>
        <p className="text-stone-400 text-sm mt-3">
          From peaceful spiritual circuits and desert dunes to tropical beaches and cosmopolitan skylines.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {TILES.map((t, i) => (
          <motion.div
            key={t.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="aspect-[4/5] rounded-xl overflow-hidden relative flex items-end p-5 group"
            data-testid={`gallery-tile-${i + 1}`}
          >
            <img
              src={t.img}
              alt={t.alt}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="relative z-10">
              <p className={`text-xs font-semibold uppercase ${t.tagCls}`}>{t.tag}</p>
              <h4 className="text-base font-bold text-white">{t.title}</h4>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
